import { render, staticRenderFns } from "./PingPong.vue?vue&type=template&id=1b98f29d&scoped=true&"
import script from "./PingPong.vue?vue&type=script&lang=js&"
export * from "./PingPong.vue?vue&type=script&lang=js&"
import style0 from "./PingPong.vue?vue&type=style&index=0&id=1b98f29d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b98f29d",
  null
  
)

export default component.exports